import { render, staticRenderFns } from "./CoffeeOrder.vue?vue&type=template&id=1dd1388b&scoped=true&"
import script from "./CoffeeOrder.vue?vue&type=script&lang=js&"
export * from "./CoffeeOrder.vue?vue&type=script&lang=js&"
import style0 from "./CoffeeOrder.vue?vue&type=style&index=0&id=1dd1388b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd1388b",
  null
  
)

export default component.exports